import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotesFormComponent } from '../notes-form/notes-form.component';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { NoteService } from 'app/modules/vehicle-inventory/services/note.service'
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-notes-list',
    templateUrl: './notes-list.component.html',
    styleUrls: ['./notes-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NotesListComponent extends EntityListComponent<Rest.InvNote>
implements OnInit {

@ViewChild(NotesFormComponent, { static: true })
NotesForm: NotesFormComponent;

title: string = this.translateService.instant('tableManagement.notes.notes');
disableSave: boolean;
@Input() vehicle: Rest.Vehicle;
isCreateGranted: boolean = false;
isDeleteGranted: boolean = false;
constructor(
    private noteService: NoteService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
    protected translateService: TranslateService
) {
    super(
        noteService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime
    );
    this.noteService = noteService;
}

ngOnInit() {
    super.ngOnInit();
    this.form = this.NotesForm;
    this.setPermissions();
}

beforeLoad() {
    if(!this.paginationRequest.sortBy){
        this.paginationRequest.sortBy = "noteDate";
        this.paginationRequest.sortAsc= false;
      }

    this.paginationRequest.filters['vehicle'] = [this.vehicle.name];
}
afterLoad() {
   
}

setPermissions(){
    const user = this.authenticationService.user;
    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_NOTE_CREATE', user);
    this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_NOTE_DELETE', user);
}

public onDeleteNote(note: Rest.InvNote) {

    this.confirmationService.confirm({
        accept: () => {
            this.deleteNote(note);
        },
        key:'notes-list'
    });
}

deleteNote(note: Rest.InvNote) {
    var that = this;
    this.noteService.deleteById(note.id).then((response) => {
        if (response) {
            that.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
            that.refresh();
        } else {
            that.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
        }
    });
}
}